<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <!-- :badge="notif.total" -->
    <template #button-content>
      <feather-icon
        badge-classes="bg-danger"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Pemberitahuan
        </h4>
        <!-- <b-badge
          pill
          variant="light-primary"
          class="text-body"
        >
          {{ notif.total }}
        </b-badge> -->
      </div>
    </li>

    <!-- @click="goDetail" -->
    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->

      <b-link
        v-for="(notification, index) in notif.data"
        :key="index"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :src="notification.avatar"
              :text="notification.avatar"
              :variant="notification.type"
            />
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder text-body">
              {{ notification.payload.data.feature }}
            </span>
          </p>
          <small class="notification-text">{{ notification.payload.title }}</small>
          <small class="notification-text"> - <b>{{ dateFormat(notification.updated_at) }} </b></small>
        </b-media>
      </b-link>

      <!-- System Notification Toggler -->
      <!-- <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">
          System Notifications
        </h6>
        <b-form-checkbox
          :checked="true"
          switch
        />
      </div> -->

      <!-- System Notifications -->
      <!-- <b-link
        v-for="notification in systemNotifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="notification.type"
            >
              <feather-icon :icon="notification.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <!-- <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
      >Hapus permberitahuan</b-button>
    </li> -->
  </b-nav-item-dropdown>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import dayjs from 'dayjs'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  setup() {
    /* eslint-disable global-require */
    const notifications = [
      {
        title: 'Surat Disposisi Masuk',
        // avatar: require('@/assets/images/avatars/6-small.png'),
        avatar: 'SE',
        subtitle:
          'Anda baru saja ditambahkan ke surat disposisi oleh Staff SE - Deadline 20-12-2021',
        type: 'light-success',
      },
      {
        title: 'Surat Disposisi Diubah',
        avatar: 'SE',
        subtitle:
          'Surat disposisi baru saja diubah oleh Staff SE - Deadline 22-12-2021',
        type: 'light-info',
      },
      {
        title: 'Mengomentari Surat Disposisi',
        avatar: 'BD',
        subtitle:
          'Bendahara baru saja mengomentari surat disposisi - Deadline 21-12-2021',
        type: 'light-danger',
      },
    ]
    /* eslint-disable global-require */

    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      notifications,
      systemNotifications,
      perfectScrollbarSettings,
    }
  },
  data() {
    return {
      notif: [],
      list: [],
    }
  },
  created() {
    this.getNotif()
  },
  methods: {
    goDetail() {
      window.location.href = `/disposisi/detail-disposisi/${'31'}`
    },

    dateFormat(time) {
      const formatted = dayjs(time).format('DD/MM/YYYY')
      if (formatted === 'Invalid Date') {
        return '-'
      }
      return formatted
    },

    async getNotif() {
      const { data } = await axios.get('siap/notification')
      this.notif = data
      this.list = data.data
    },
  },
}
</script>

<style>
</style>
